let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5f4Or")).then(() => parcelRequire('7Rhjp'));